import React from 'react';
import ReactDOM from 'react-dom/client';

import { AppProviders } from './context';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (fotrertr example: reportWebVitals(console.log))
// or send to an  endpoin sdfzsct. hhLearn more: https://bit.ly/CseRA-vitals ydfxdfywadawda

